import React from "react";
import { motion } from "framer-motion";
import "./AboutUs.css";
import aboutImg from "./office2.jpg";

const competencyData = [
  {
    key: "display",
    icon: "/icons/competencies/tft-display.png",
    title: "TFT Display Solutions:",
    desc: "We design and supply high-resolution TFT LCDs, capacitive touch panels, and custom display interfaces (UART, MIPI, LVDS, RGB) for industrial, medical, consumer, and automotive applications.",
  },
  {
    key: "embedded",
    icon: "/icons/competencies/embedded-design.png",
    title: "Embedded Design Services:",
    desc: "From PCB layout and firmware development to IoT integration and RTOS, we deliver end-to-end embedded solutions tailored to your product roadmap.",
  },
  {
    key: "ems",
    icon: "/icons/competencies/electronics-manufacturing.png",
    title: "Electronics Manufacturing Services (EMS):",
    desc: "Our EMS capabilities include SMT assembly, component sourcing, functional testing, and final box build — ensuring cost efficiency and quality assurance.",
  },
];

const AboutUs = () => {
  return (
    <section className="about-section">
      {/* ── Heading (matches other sections, sits above image + text) ── */}
      <motion.div
        className="about-heading-wrap"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
      >
        <motion.h2
          className="about-heading"
          variants={{
            hidden: { opacity: 0, y: -22 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
          }}
        >
          About <span>Us</span>
        </motion.h2>
        <motion.div
          className="about-ornament"
          variants={{
            hidden: { opacity: 0, scaleX: 0 },
            visible: { opacity: 1, scaleX: 1, transition: { duration: 0.7, delay: 0.2, ease: "easeOut" } },
          }}
        >
          <div className="about-orn-line" />
          <div className="about-orn-gem" />
          <div className="about-orn-line" />
        </motion.div>
      </motion.div>

      <div className="about-container">

        {/* Image Left */}
        <motion.div
          className="about-image-wrap"
          initial={{ opacity: 0, x: -80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <img src={aboutImg} alt="About Us" className="about-image" />
        </motion.div>

        {/* Text Right */}
        <motion.div
          className="about-content"
          initial={{ opacity: 0, x: 80 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          <p className="about-text">
            <strong>Engineering Trust. Building Tomorrow.</strong> Founded in 2021,{" "}
            <strong>BIBA Electronics Pvt Ltd</strong> is a dynamic technology partner
            specializing in <strong>TFT display modules, embedded system design</strong>,
            and <strong>electronics manufacturing services (EMS)</strong>. We serve OEMs,
            startups, and global brands with end-to-end solutions that combine engineering
            precision, scalable production, and regulatory clarity.
          </p>

          <p className="about-text">
            🇮🇳 <strong>Proudly Made in India</strong>
            <br />
            We are deeply aligned with the Government of India's initiatives—including{" "}
            <strong>Make in India, Atmanirbhar Bharat, and Vocal for Local</strong>.
            Our operations are rooted in India's growing electronics ecosystem, enabling
            us to deliver cost-effective, compliant, and export-ready solutions that
            support national self-reliance and global competitiveness.
          </p>

          <h3 className="about-subheading">Our Core Competencies</h3>
          <div className="competency-list">
            {competencyData.map((item) => (
              <div className="competency-item" key={item.key}>
                <div className="competency-icon">
                  <img
                    src={item.icon}
                    alt={item.title.replace(":", "")}
                    className="competency-icon-img"
                    loading="lazy"
                  />
                </div>
                <p className="competency-text">
                  <strong>{item.title}</strong> {item.desc}
                </p>
              </div>
            ))}
          </div>

        </motion.div>
      </div>
    </section>
  );
};

export default AboutUs;